"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var unregisterHttpPlugin_1 = require("./Network/unregisterHttpPlugin");
var unregisterHttpRequestMonitorCallbacks_1 = require("./Network/unregisterHttpRequestMonitorCallbacks");
function shutdownConfig(context) {
    var shaka = context.shaka, httpRequestMonitor = context.httpRequestMonitor, plugins = context.plugins;
    // shutdown plugins
    plugins.forEach(function (plugin) {
        plugin.shutdownPlugin();
    });
    // unregister callbacks that feed information to abrManager
    unregisterHttpRequestMonitorCallbacks_1.default(httpRequestMonitor);
    // shutdown internal timers for bandwidth-estimate event
    httpRequestMonitor.shutdown();
    unregisterHttpPlugin_1.default(shaka);
}
exports.default = shutdownConfig;
//# sourceMappingURL=shutdownConfig.js.map